<template>
  <div>
    <LoadingAnimation full-page v-if="loading" />
    <TemplateModal
      ref="modal"
      center
      empty width="650" :sendFunction="onCreateReport" :key="key" :text="{title: {create: localStorage.translations.pages.common.buttons.confirm}}">
      <template v-slot:activator>
        <v-btn
          @click="openModal"
          :width="size"
          :height="size"
          :elevation="0" fab
        >
          <v-icon :size="$vuetify.breakpoint.smAndDown ? 25 : 35">mdi-check</v-icon>
        </v-btn>
      </template>
      <div class="container_btn d-flex justify-space-around">
        <v-hover v-slot="{ hover }">
          <v-btn
            @click="closeModal"
            :width="size"
            :height="size"
            :elevation="0"
            fab dark :outlined="!hover"
            color="red"
          >
            <v-icon :size="$vuetify.breakpoint.smAndDown ? 25 : 35">mdi-close</v-icon>
          </v-btn>
        </v-hover>
        <v-hover v-slot="{ hover }">
          <v-btn
            type="submit"
            :width="size"
            :height="size"
            :elevation="0"
            fab dark :outlined="!hover"
            color="#277FAF"
          >
            <v-icon :size="$vuetify.breakpoint.smAndDown ? 25 : 35">mdi-check</v-icon>
          </v-btn>
        </v-hover>
      </div>
    </TemplateModal>
  </div>
</template>

<script>
import LoadingAnimation from "components/LoadingAnimation";
import TemplateModal from "components/templates/TemplateModal";
import {mapActions, mapGetters} from "vuex";
export default {
  name: "StatisticProjectReportsApproveModal",
  components: {TemplateModal, LoadingAnimation},
  props: {
    size: {
      type: [Number, String, Function],
    },
    works: {
      type: Object,
      default: () => {
        return {
          work_types: [],
          extras: []
        }
      }
    },
    notes: Boolean,
  },
  data: () => ({
    loading: false,
    key: 0,
  }),
  computed: {
    ...mapGetters('workClientProjectsClientReports', ['workClientProjectsClientReportsGeneralNote'])
  },
  methods: {
    ...mapActions('workClientProjectsClientReports', [
      'onWorkClientProjectsClientReportsBillCreate',
      'onWorkClientProjectsClientReportsBillApprove'
    ]),
    openModal() {
      this.$refs.modal.openModal()
    },
    closeModal() {
      this.$refs.modal.closeModal()
    },
    async onCreateReport() {
      let data = {
        period_report_id: this.$route.params.report_id,
        employee_reports: Object.assign([], this.works.work_types),
        work_extras: Object.assign([], this.works.extras),
        report_with_employee_notes: this.notes ? 1 : 0,
        general_note: this?.workClientProjectsClientReportsGeneralNote[this.$route.params.report_id]?.reportGeneralNote || '',
      }
      await this.onWorkClientProjectsClientReportsBillCreate({data})
        .then(res => {
          this.onApproveReport(res.data.data.id)
        })
        .catch(() => {
          this.loading = false
          this.$store.dispatch(
            'popup/onMessage',
            {message: this.localStorage.translations.pages.common.notifications['oshibka'], IsError: true},
            {root: true}
          )
        })
    },
    async onApproveReport(id) {
      this.onWorkClientProjectsClientReportsBillApprove({id})
        .then(() => {
          this.$router.push({name: 'timeControlShowReportsViewBill', params: {bill: id}})
        })
    }
  }
}
</script>

<style scoped lang="scss">
.container_btn {
  width: 100%;
  margin-top: 30px;
}
</style>
